import fetch from 'isomorphic-unfetch';

import { fetchOpts, baseUrlOf } from '../../lib/ssr';

const profile = async (req, res) => {
  const baseUrl = baseUrlOf(req);
  const response = await fetch(`${baseUrl}/api/profile`, fetchOpts(req, res));
  const profile = response.status === 200 ? await response.json() : null;
  return profile;
};

const update = async profile => {
  const response = await fetch('/api/profile', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(profile)
  });

  return response;
};

const user = {
  profile,
  update
};

export default user;
